import Footer from './Assets/Footer.js'
import Header from './Assets/Header.js'
import Form from './Assets/Form.js'

function BookingPage() {
    return (
        <>
        <Header/>
        <section class="BP-Section">
            <Form/>
        </section>
        <Footer/>
        </>
    )
}

export default BookingPage